<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "PortalManage"
    }
</script>

<style scoped>

</style>
